import * as moment from 'moment/moment'

export const DOMEN =
    ENV_IS_DEV && window?.origin === 'https://euro-ins.lh:3000'
        ? 'https://api.euro-ins.lh'
        : ENV_IS_DEV && window?.origin === 'https://api.euro-ins.lh'
        ? 'https://api.euro-ins.lh'
        : ENV_IS_DEV && window?.origin === 'http://api.euro-ins.ru'
        ? 'http://api.euro-ins.ru'
        : window?.origin === 'http://testapi.euro-ins.ru'
        ? 'http://testapi.euro-ins.ru'
        : 'https://api.euro-ins.ru'

export const URL_GET_ADDRESS_SUGGESTIONS =
    'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address'
export const URL_GET_ADDRESS =
    'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/address'
export const URL_GET_BANK_SUGGESTIONS =
    'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/bank'
export const URL_GET_BANK = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/bank'
export const DADATA_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: 'Token 7977a2f68476d3e36e334f80478e72773690b72a',
}
export const URL_FIND_LEGAL_COUNTERPARTY = `/admin/counterparty/find/legal`

const ROOT_SECTIONS = {
    'api.euro-ins.ru': '/admin',
    'agent.euro-ins.ru': '',
    'api.euro-ins.lh': '/admin',
    'euro-ins.lh': '/admin',
    'agent.euro-ins.lh': '',
    '192.168.5.6': '/admin',
}

export const ROOT_SECTION = ROOT_SECTIONS[window.location.hostname] || ''

export const STANDARD_ITEM_RULES = [{required: true, message: 'Введите данные'}]

export const NOT_EMPTY_LIST_RULES = [
    {
        validator: async (_, names) => {
            if (!names || names.length < 1) {
                return Promise.reject(new Error('Необходимо указать как минимум одну позицию'))
            }
        },
    },
]

export const INSURANT_TOOLTIP =
    'Страхователь (заявитель) - это дееспособное физическое лицо, достигшее 18 лет и заключившее договор страхования'

export const TOP_OFFSET_FOR_MODAL = 80

export const SENTRY_HOST = 'sentry.euro-ins.ru'

export const UNIVERSAL_CALC_URL = `${ROOT_SECTION}/kias/calc/list`

export type Currencies = 'EUR' | 'RUB' | 'USD' | string
